/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import DS from 'ember-data';
import moment from 'moment-timezone';
import TIME_ZONES, { LOCAL_TIME_ZONE } from 'cio/utils/time-zones';
import { isPresent, isEmpty } from '@ember/utils';

interface CioNewsletterSentTimeSummaryArgs {
  timestamp: number;
  timezone: string;
  tzMatchEnabled: boolean;
}

const DAY_FORMAT = 'MMMM DD, YYYY';
const TIME_FORMAT = 'h:mm A';

export default class CioNewsletterSentTimeSummary extends Component<CioNewsletterSentTimeSummaryArgs> {
  @service store!: DS.Store;

  currentTime = moment.utc();

  get time() {
    return moment.utc(this.args.timestamp * 1000);
  }

  get localTime() {
    let { time } = this;
    let { timezone } = this.args;

    let clonedTime = time.clone();

    if (isPresent(timezone)) {
      clonedTime.tz(timezone);
    } else {
      clonedTime.tz(moment.tz.guess());
    }

    return clonedTime;
  }

  get isToday() {
    let localCurrentTime = this.currentTime.clone().local();

    return this.localTime.isSame(localCurrentTime, 'day');
  }

  get isYesterday() {
    let localCurrentTime = this.currentTime.clone().local().subtract(1, 'days').startOf('day');

    return this.localTime.isSame(localCurrentTime, 'day');
  }

  get formattedTime() {
    return this.localTime.format(TIME_FORMAT);
  }

  get formattedDay() {
    return this.localTime.format(DAY_FORMAT);
  }

  get timezoneLabel() {
    let { timezone } = this.args;

    if (isEmpty(timezone)) {
      timezone = LOCAL_TIME_ZONE.value;
    }

    let timezoneObject = TIME_ZONES.find((timezoneDef) => timezoneDef.value === timezone);
    return timezoneObject != null ? timezoneObject.label : timezone;
  }
}
